module.exports = __webpack_public_path__ + "static/media/icon-partner-search.fc9002bd.svg";